import { AxiosInstance } from 'axios';
import { BookRole, NotifyType } from '../../../common/enum';
import { AccountDTO, updateAccountParams } from '../../types/apiType';

class UserService {
  constructor(private ApiClient: AxiosInstance) {}

  invite = async (params: { email: string; firstName: string; secondName: string }) => {
    const { data } = await this.ApiClient.post('/users/invite', params);
    return data;
  };

  lists = async () => {
    const { data } = await this.ApiClient.get('/users');
    return data;
  };

  listContributors = async () => {
    const { data } = await this.ApiClient.get('/users/contributor');
    return data;
  };

  removeUserFromAccount = async (params: { id: string }) => {
    const { data } = await this.ApiClient.delete('/users/authourised', { params });
    return data;
  };

  updateUserAuthorised = async (params: {
    id: string;
    add: { book_id: string; role: BookRole | string; pages?: number[] } | null;
    deletes: { book_id: string; pages: string[]; role: string }[];
  }) => {
    const { data } = await this.ApiClient.put('/users/authorised/user', params);
    return data;
  };

  updateBookAuthorised = async (params: {
    id: string;
    deletes: { user_id: string; pages: string[]; role: string; update_id?: string }[];
    publishing_date?: string;
  }) => {
    const { data } = await this.ApiClient.put('/users/authorised/book', params);
    return data;
  };

  getSubscriber = async () => {
    const { data } = await this.ApiClient.get('/users/novu/subscriber');
    return data;
  };

  getAccount = async (): Promise<AccountDTO> => {
    const { data } = await this.ApiClient.get('/account');
    return data;
  };

  updateAccount = async (params: updateAccountParams) => {
    const { data } = await this.ApiClient.put('/account', params);
    return data;
  };

  deleteAccount = async () => {
    const { data } = await this.ApiClient.delete('/users');
    return data;
  };

  confirmUser = async (params: { code: string; username: string; clientId: string }) => {
    const { data } = await this.ApiClient.get('/account/confirm-user', { params });
    return data;
  };

  sendNotify = async (params: { type: NotifyType }) => {
    const { data } = await this.ApiClient.put('/users/novu/send-notify', params);

    return data;
  };

  remindUser = async (params: { accountId: string; bookId: string }) => {
    const { data } = await this.ApiClient.put('users/remind-user', params);
    return data;
  };
}

export default UserService;
